import React, { useEffect, useRef, useState } from "react";
import CCPanel from "./CCPanel";
import CCControlBar from "./CCControlBar";
import CCFileTree from "./CCFileTree";

const YouLaberIDEShell = ({
  apiUrl,
  header = null,
  ccSelectedDevice,
  ccMessages,
  ccStreamingText,
  ccThinkingText,
  ccSessionState,
  ccStatus,
  ccInitInfo,
  ccPendingQuestion,
  ccTaskInfo,
  ccTokenUsage,
  ccFileTree,
  ccRoster,
  onSendMessage,
  onInterrupt,
  onQuestionRespond,
  onSendControl,
  onCompact,
  onClearHistory,
  onExportChatlog,
}) => {
  const [ideWidth, setIdeWidth] = useState(50);
  const [treeVisible, setTreeVisible] = useState(true);
  const [editorVisible, setEditorVisible] = useState(false);
  const [workspaceOpenRequest, setWorkspaceOpenRequest] = useState(null);
  const dragRef = useRef(null);
  const bodyRef = useRef(null);

  const openEditor = () => {
    setEditorVisible(true);
    setIdeWidth((prev) => Math.max(prev, 50));
  };

  const setTreeOpen = (open) => {
    setTreeVisible(open);
  };

  const setEditorOpen = (open) => {
    setEditorVisible(open);
    if (!open && treeVisible) {
      setIdeWidth(50);
    }
  };

  useEffect(() => {
    const onMove = (e) => {
      if (!dragRef.current) return;
      const { startX, startWidth, totalWidth } = dragRef.current;
      const deltaPct = ((e.clientX - startX) / totalWidth) * 100;
      setIdeWidth(Math.max(38, Math.min(68, startWidth + deltaPct)));
    };
    const onUp = () => {
      dragRef.current = null;
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
    };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
    };
  }, []);

  const paneBasis = editorVisible
    ? `${ideWidth}%`
    : treeVisible
      ? "240px"
      : "48px";

  return (
    <div style={{ flex: 1, minHeight: 0, width: "100%", display: "flex", flexDirection: "column", background: "#0a0d12" }}>
      {header}
      <div ref={bodyRef} style={{ flex: 1, minHeight: 0, display: "flex", overflow: "hidden" }}>
        <div style={{ flex: `0 0 ${paneBasis}`, minWidth: editorVisible ? "420px" : treeVisible ? "220px" : "48px", overflow: "hidden" }}>
          <CCFileTree
            ccFileTree={ccFileTree}
            deviceId={ccSelectedDevice?.device_id || ""}
            apiUrl={apiUrl}
            openPathRequest={workspaceOpenRequest}
            treeVisible={treeVisible}
            editorVisible={editorVisible}
            onTreeVisibleChange={setTreeOpen}
            onEditorVisibleChange={setEditorOpen}
            onEditorOpen={openEditor}
          />
        </div>
        {editorVisible && (
          <div
            onMouseDown={(e) => {
              dragRef.current = {
                startX: e.clientX,
                startWidth: ideWidth,
                totalWidth: bodyRef.current?.clientWidth || window.innerWidth,
              };
              document.body.style.cursor = "col-resize";
              document.body.style.userSelect = "none";
            }}
            title="拖动调整编辑器和对话区域宽度"
            style={{ width: 6, cursor: "col-resize", background: "#161b22", borderLeft: "1px solid #21262d", borderRight: "1px solid #21262d", flexShrink: 0 }}
          />
        )}
        <CCPanel
          ccMessages={ccMessages}
          ccStreamingText={ccStreamingText}
          ccThinkingText={ccThinkingText}
          ccSessionState={ccSessionState}
          ccStatus={ccStatus}
          ccSelectedDevice={ccSelectedDevice}
          ccInitInfo={ccInitInfo}
          ccPendingQuestion={ccPendingQuestion}
          ccRoster={ccRoster}
          onSendMessage={onSendMessage}
          onInterrupt={onInterrupt}
          onQuestionRespond={onQuestionRespond}
          onWorkspaceFileOpen={(path) => {
            openEditor();
            return new Promise((resolve) => {
              setWorkspaceOpenRequest({ path, ts: Date.now(), resolve });
            });
          }}
          bottomControlBar={
            <CCControlBar
              ccTaskInfo={ccTaskInfo}
              ccTokenUsage={ccTokenUsage}
              ccSessionState={ccSessionState}
              onSendControl={onSendControl}
              onCompact={onCompact}
              onClearHistory={onClearHistory}
              onExportChatlog={onExportChatlog}
            />
          }
        />
      </div>
    </div>
  );
};

export default YouLaberIDEShell;
